var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-select',{staticClass:"lang-box",on:{"change":_vm.handleLangChange},model:{value:(_vm.langValue),callback:function ($$v) {_vm.langValue=$$v},expression:"langValue"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }